// @flow

import React from 'react'
import Bool from './bool'
import RatingValueChange from './rating-value-change'

type Props = {
  rule: ?Object,
  onChange: (change: Object) => void,
  tooltip?: Array<string>,
  alert?: string,
}

const componentForRule = (ruleType) => {
  switch (ruleType) {
    case 1: return Bool
    case 2: return RatingValueChange
    case 3: return RatingValueChange
    case 4: return RatingValueChange
    case 5: return RatingValueChange
    case 6: return RatingValueChange
    case 7: return RatingValueChange
    case 8: return RatingValueChange
    case 9: return RatingValueChange
    case 10: return RatingValueChange
    case 11: return RatingValueChange
    default: return null
  }
}

const RawRule = (props: Props) => {
  if (props.rule && props.rule.ruleType) {
    const Component = componentForRule(props.rule.ruleType)
    return Component
      ? (<Component
        rule={props.rule}
        raiseChange={props.onChange}
        tooltip={props.tooltip}
        alert={props.alert}
      />)
      : <div>UNIMPLEMENTED: {props.rule && props.rule.ruleTypeName} {props.rule && props.rule.name}</div>
  }
  return null
}

export default RawRule



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/rule.js